// extracted by mini-css-extract-plugin
export default {"form_label":"styles_form_label__AoHu4"};